<app-login-shell
  [mode]="'admin'"
  [loading]="loading"
  [error]="loginError"
  [startInRecover]="startInRecover"
  [recoverSuccess]="recoverSuccess"
  [recoverError]="recoverError"
  (submit)="onShellSubmit($event)"
  (recover)="onShellRecover($event)">
</app-login-shell>
